/**
 * BrandMark — uses the official BAS1C logo artwork.
 *
 *   variant="dark"   → white-on-black (default)
 *   variant="light"  → black-on-white
 *
 *   size: "xs" | "sm" | "md" | "lg" | "xl" | "huge"
 */
export const BrandMark = ({ size = "sm", variant = "dark", className = "" }) => {
  const dims = {
    xs: "h-10 w-10",
    sm: "h-20 w-20",       // navbar (was h-12 — increased)
    md: "h-32 w-32",
    lg: "h-56 w-56",
    xl: "h-80 w-80",
    huge: "h-[min(40vh,450px)] w-[min(40vh,450px)]", // half of previous huge
  }[size];

  const src =
    variant === "light"
      ? "/logo-light-circle.jpg"
      : size === "huge" || size === "xl"
        ? "/logo-transparent.png"
        : "/logo-dark.jpg";

  return (
    <img
      src={src}
      alt="BAS1C. The Brand"
      data-testid={`brand-mark-${size}`}
      className={`block ${dims} object-contain select-none ${className}`}
      draggable={false}
    />
  );
};
